module.exports = __webpack_public_path__ + "instagram.svg?16dd1b1215c4d451fcb4ba97dd01e8a2";